<template>
  <div v-if="data">
    <Top />
    <div class="container">
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <div class="clearfix--min"></div>
          <h2 class="text-primary-fh" v-html="data.dashboard.welcomeHeader + fullname"></h2>
          <div class="card dashboard-card">
            <div class="header-wrapper">
              <h2 class="text-primary-fh left-header" v-html="data.dashboardNoReferral.infoHeader"></h2>
            </div>
            <p v-html="data.dashboardNoReferral.infoText"></p>
          </div>
          <!-- Gen negativ -->
          <div v-if="isGeneNegative">
            <div class="card dashboard-card" v-if="!checkForBloodTestAndAssessmentDone">
              <div class="div-loader d-block">Laddar provsvar</div>
              <div class="clearfix"></div>
            </div>
            <div class="card dashboard-card" v-if="bloodtestData && checkForBloodTestAndAssessmentDone">
              <h5 class="text-primary-fh left-header">Provsvar</h5>
              <p v-html="data.dashboard.labresultsCardText"></p>
              <small class="text-right">{{ getTestDate(bloodtestData) }}</small>
              <ul class="ul-list list-group list-group-flush bg-transparent">
                <li class="list-group-item bg-transparent">
                  Totalkolesterol <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.totalKolesterol }} {{ bloodtestData.totalKolesterolUnit }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  Triglycerider <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.triglycerider }} {{ bloodtestData.triglyceriderUnit }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  HDL kolesterol <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.hdl }} {{ bloodtestData.hdlUnit }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  LDL kolesterol <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.ldl }}
                    {{ bloodtestData.ldlUnit }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  Lipoprotein (a) <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.lipoProteinA }} {{ bloodtestData.lipoProteinAUnit }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
              </ul>
              <ul class="ul-list list-group list-group-flush bg-transparent">
                <div class="clearfix--min"></div>
                <h5 class="text-primary-fh left-header" v-html="data.dashboard.referenceIntervalText"></h5>
                <li class="list-group-item bg-transparent">
                  Totalkolesterol
                  <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.totalKolesterolReferenceInterval }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  Triglycerider
                  <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.triglyceriderReferenceInterval }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  HDL kolesterol
                  <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.hdlReferenceInterval }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
                <li class="list-group-item bg-transparent">
                  LDL kolesterol
                  <span class="lab-results-values" v-if="bloodtestData">
                    {{ bloodtestData.ldlReferenceInterval }}
                  </span>
                  <span class="lab-results-values" v-if="!bloodtestData">-</span>
                </li>
              </ul>
            </div>
            <!-- Om bedömning är utförd gällande blodprovet från det kliniska interfacet -->
            <div class="card dashboard-card">
              <p class="text-dark">
                <strong>Från vårdgivaren (bedömning)</strong>:
                <br />
                <span v-html="(assessmentData && assessmentData.patientText) ||
                  'Här kommer meddelande från din vårdgivare att visas'"></span>
              </p>
            </div>
            <div class="card dashboard-card">
              <p class="text-dark">
                <strong>Från vårdgivaren (beslut)</strong>:
                <br />
                <span v-html="(diagnosisData && diagnosisData.patientText) ||
                  'Här kommer meddelande från din vårdgivare att visas'"></span>
              </p>
            </div>
          </div>
          <div class="clearfix"></div>
          <div class="card dashboard-card" v-if="!isGeneNegative">
            <p class="text-dark">
              <strong>Från vårdgivaren (beslut)</strong>:
              <br />
              <span v-html="(diagnosisData && diagnosisData.patientText) ||
                'Här kommer meddelande från din vårdgivare att visas'"></span>
            </p>
          </div>
        </div>
        <div class="col-sm"></div>
      </div>
      <div class="row">
        <div class="col-sm"></div>
        <div class="col-md-6">
          <div class="card dashboard-card"
            v-show="(!referralToRegionCreated && hasDiagnosis && (diagnosisData.fhDiagnosisValue !== 5)) && !isGeneNegative">
            <h5 class="text-primary-fh left-header">Ta kontakt med en läkare</h5>
            <p>Välj i listan vilket vårdställe som passar dig bäst.</p>
            <select class="form-control" v-model="careCenter">
              <option :value="0">Ange vårdställe</option>
              <option v-for="(region, center) in data.misc.facilitylist" :value="center" v-bind:key="center">
                {{ center }}
              </option>
            </select>
            <div class="clearfix"></div>
            <p class="text-primary-fh text-center">..eller skriv i fritext. Var noga med stavningen.</p>
            <input
              class="form-control form-control-lg"
              type="text"
              v-model="careFacility"
              placeholder="Exempelvis: Huddinge vårdcentral"
            />
            <div class="clearfix"></div>
            <button
              class="btn btn-primary btn-lg btn-block create-remittance-btn"
              :disabled="(careCenter === 0 && careFacility.length === 0)"
              @click="referralToRegion()">
            Skapa remiss
            </button>
          </div>
          <div class="card dashboard-card bg-light" v-show="referralToRegionCreated">
            <h5 class="text-dark left-header">Kallelse skickas med post</h5>
              <p class="text-dark" v-html="data.dashboard.referralToRegionText"></p>
              <p class="text-dark">
                Du kommer att få en kallelse med brev från {{ (careCenter || careFacility) || ' din valda mottagning' }}.
              </p>
          </div>
        </div>
        <div class="col-sm"></div>
      </div>
    </div>
    <Bottom />
  </div>
</template>

<script>
import Top from '../../src/components/Top'
import Bottom from '../../src/components/Bottom'
import { request } from '../plugins/datocms'
import config from '../../config/index.js'
import axios from '../plugins/axios'

export default {
  name: 'dashboardnf',
  components: {
    Top,
    Bottom
  },
  data () {
    return {
      data: null,
      fullname: '',
      careFacility: '',
      careCenter: 0,
      assessmentData: null,
      bloodtestData: null,
      diagnosisData: null,
      hasDiagnosis: false,
      hasTakenBloodTest: false,
      referralToRegionCreated: false,
      isGeneNegative: false,
      checkForBloodTestAndAssessmentDone: false
    }
  },
  methods: {
    getTestDate (bloodtest) {
      if (bloodtest !== null) {
        return new Date(bloodtest.testDate).toLocaleDateString()
      } else {
        return '-'
      }
    },
    toTitleCase (phrase) {
      if (phrase) {
        return phrase
          .toLowerCase()
          .split(' ')
          .map(word => word.charAt(0).toUpperCase() + word.slice(1))
          .join(' ')
      }
    },
    async checkForDiagnosis () {
      axios._get(config.diagnosisUri).then(response => {
        if (response) {
          this.diagnosisData = response.data.fhDiagnosis
          if (this.diagnosisData && this.diagnosisData.fhDiagnosisValue !== 0) {
            this.hasDiagnosis = true
          }
        }
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get diagnosis: ' + error)
        }
      })
    },
    async checkForBloodTestAndAssessment () {
      axios._get(config.bloodtestUri).then(response => {
        if (response) {
          this.bloodtestData = response.data.bloodTest
          this.assessmentData = response.data.assessment
          if (this.bloodtestData) {
            try {
              const LDLs = JSON.parse(this.bloodtestData.ldl)
              this.bloodtestData.ldl = LDLs.ldlHighestMeasured
                ? LDLs.ldlHighestMeasured.replace(/,/g, '.') : LDLs.ldlUncalculated.replace(/,/g, '.')
            } catch (error) {
              console.log(error)
            }
          }
          this.checkForBloodTestAndAssessmentDone = true
          if (this.bloodtestData && this.assessmentData.bloodSampleAssessmentValue !== 0) {
            this.hasTakenBloodTest = true
          }
        }
      }).catch((error) => {
        if (error.response && error.response.status === 401) {
          window.location.href = window.location.origin.concat('/error')
        } else {
          console.log('Could not get bloodtest: ' + error)
        }
      })
    },
    referralToRegion () {
      let loader = this.$loading.show({
        opacity: 0.9,
        backgroundColor: '#B5B5B5'
      })
      const healthCenter = (this.careCenter !== 0) ? this.careCenter : this.careFacility
      if (healthCenter.length > 0) {
        axios.postReferralHealthCenter(config.referralHealthcenterUri, healthCenter).then((response) => {
          if (response.status === 200) {
            this.referralToRegionCreated = true
            loader.hide()
          }
        }, (error) => {
          if (error.response && error.response.status === 401) {
            loader.hide()
            window.location.href = window.location.origin.concat('/error')
          } else {
            loader.hide()
            console.log(error)
          }
        })
      }
    }
  },
  computed: {},
  async beforeMount () {
    sessionStorage.removeItem('hasVisitedDashboard')
    sessionStorage.setItem('hasVisitedDashboardNoReferral', 'true')
    this.fullname = sessionStorage.getItem('fullname')
    this.checkForDiagnosis()
    if (sessionStorage.getItem('isGeneNegative') === 'true') {
      this.isGeneNegative = true
      await this.checkForBloodTestAndAssessment()
    }
  },
  async mounted () {
    this.data = await request({
      query: `
        {
          dashboard {
            labresultsCardText
            referenceIntervalText
            referralToRegionText
            welcomeHeader
          }
          dashboardNoReferral {
            infoHeader
            infoText
          }
          misc {
            facilitylist
          }
        }
      `
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.container {
  margin-top: 125px;
  margin-bottom: 50px;
  min-height: 65vh;
}
@media screen and (min-width: 800px) {
  .header-wrapper {
    display: flex;
  }
}
.create-remittance-btn {
  margin-bottom: 1vh;
}
.ul-list {
  border-top: 0;
  text-align: left;
  display: inline-grid;
}
.left-header {
  text-align: left;
}
.text-right {
  display: inline;
  position: absolute;
  top: 0;
  right: 0;
  margin: 1.5em;
}
.margin-left {
  margin-left: 30px;
}
.lab-results-values {
  float: right;
  font-weight: bold;
  font-size: 1.1em;
}
.samplepoints-link span {
  vertical-align: text-top;
}
.dashboard-card {
  padding: 15px 15px 0 15px;
  background: #e5f1f5;
  margin-bottom: 25px;
  border: 2px solid #069ccc;
  border-radius: 15px;
}
.no-border {
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/DashboardNoReferral.vue